import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col, ListGroup, InputGroup } from 'react-bootstrap';
import api from '../../api/axios';

const AgregarPedidoModal = ({ show, onHide, businessId, mesaId, onPedidoConfirmado }) => {
  const [categorias, setCategorias] = useState([]);
  const [productos, setProductos] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('');
/*   const [pedido, setPedido] = useState([]); */
  const [itemsGuardados, setItemsGuardados] = useState([]);
const [itemsNuevos, setItemsNuevos] = useState([]);

useEffect(() => {
  if (show && businessId && mesaId) {
    fetchCategorias();
    setCategoriaSeleccionada('');
    setProductos([]);
    fetchPedidoExistente(); // ← carga ítems del pedido abierto
  }
}, [show, businessId, mesaId]);





  const fetchCategorias = async () => {
    try {
      const res = await api.get(`/categories?business_id=${businessId}`);
      setCategorias(res.data);
    } catch (err) {
      console.error('Error al traer categorías:', err);
    }
  };

  const fetchProductos = async (categoriaId) => {
    try {
      const res = await api.get(`/products?business_id=${businessId}&category_id=${categoriaId}`);
      setProductos(res.data);
    } catch (err) {
      console.error('Error al traer productos:', err);
    }
  };

const agregarProducto = (producto) => {
  setItemsNuevos(prev => {
    const existente = prev.find(p => p.producto_id === producto.id);
    if (existente) {
      return prev.map(p =>
        p.producto_id === producto.id
          ? { ...p, cantidad: p.cantidad + 1 }
          : p
      );
    } else {
      return [...prev, {
        producto_id: producto.id,
        nombre: producto.name,
        cantidad: 1,
        observacion: '',
        price: producto.price
      }];
    }
  });
};


const quitarProducto = (index) => {
  setItemsNuevos(prev => prev.filter((_, i) => i !== index));
};


const actualizarCampo = (index, campo, valor) => {
  setItemsNuevos(prev => prev.map((p, i) =>
    i === index ? { ...p, [campo]: valor } : p
  ));
};


const confirmarPedido = async () => {
  try {
    const items = itemsNuevos.map(p => ({
      producto_id: p.producto_id,
      cantidad: p.cantidad,
      observaciones: p.observacion || ''
    }));

    await api.post(`/mesas/${mesaId}/pedido`, { items });

//  Emitir comanda (para lo nuevo cargado)
/*     await api.post(`/mesas/${mesaId}/emitir-comanda`); */

    onPedidoConfirmado();
    onHide();
  } catch (err) {
    console.error('Error al confirmar pedido:', err);
    alert('No se pudo guardar el pedido');
  }
};


const fetchPedidoExistente = async () => {
  try {
    const res = await api.get(`/mesas/${mesaId}/pedidos-emitidos?business_id=${businessId}`);
    const items = res.data || [];

    // Podés sumar info de productos si querés precios más precisos
    const allProductos = await api.get(`/products?business_id=${businessId}`);
    const productosMap = {};
    allProductos.data.forEach(p => {
      productosMap[p.id] = p.price;
    });

    const formateados = items.map(i => ({
      producto_id: i.producto_id,
      nombre: i.nombre,
      cantidad: i.cantidad,
      observacion: i.observacion || '',
      price: productosMap[i.producto_id] || i.price || 0
    }));

    setItemsGuardados(formateados);
    setItemsNuevos([]);
  } catch (err) {
    console.error('Error al cargar pedidos emitidos:', err);
  }
};





useEffect(() => {
  if (categoriaSeleccionada !== '') {
    fetchProductos(categoriaSeleccionada);
  } else {
    setProductos([]);
  }
}, [categoriaSeleccionada]);


const calcularTotal = () => {
  return itemsNuevos.reduce((acc, p) => acc + (p.price * (p.cantidad || 1)), 0);
};



  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Agregar pedido</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Categoría</Form.Label>
          <Form.Select
            value={categoriaSeleccionada}
            onChange={(e) => setCategoriaSeleccionada(e.target.value)}

          >
<option value="">Seleccioná una categoría</option>

            {categorias.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </Form.Select>
        </Form.Group>

        <Row>
          {productos.map(p => (
            <Col md={6} key={p.id} className="mb-2">
              <Button
                variant="outline-primary"
                className="w-100"
                onClick={() => agregarProducto(p)}
              >
                {p.name} - ${p.price}
              </Button>
            </Col>
          ))}
        </Row>

     {itemsGuardados.length > 0 && (
  <>
    <h6 className="mt-4">Pedido existente:</h6>
    <ListGroup className="mb-3">
  {itemsGuardados.map((p, index) => (
    <ListGroup.Item key={`guardado-${index}`}>
      <Row>
        <Col>
          <strong>{p.cantidad} x {p.nombre}</strong>
          {p.observacion && <div style={{ fontSize: '0.85rem', color: '#666' }}>({p.observacion})</div>}
        </Col>
        <Col className="text-end">
<span>${(p.price || 0) * p.cantidad}</span>

        </Col>
      </Row>
    </ListGroup.Item>
  ))}
</ListGroup>

  </>
)}

<h6>Nuevo pedido:</h6>
<ListGroup>
  {itemsNuevos.map((p, index) => (
    <ListGroup.Item key={index}>
      <Row>
        <Col md={4}><strong>{p.nombre}</strong></Col>
        <Col md={2}>
          <Form.Control
            type="number"
            min="1"
            value={p.cantidad}
            onChange={(e) => actualizarCampo(index, 'cantidad', parseInt(e.target.value))}
          />
        </Col>
        <Col md={4}>
          <Form.Control
            placeholder="Observaciones"
            value={p.observacion}
            onChange={(e) => actualizarCampo(index, 'observacion', e.target.value)}
          />
        </Col>
        <Col md={2} className="text-end">
          <Button variant="outline-danger" size="sm" onClick={() => quitarProducto(index)}>
            Quitar
          </Button>
        </Col>
      </Row>
    </ListGroup.Item>
  ))}
</ListGroup>

        
      </Modal.Body>
      <Modal.Footer>
   <div className="text-end mt-2">
<div className="text-end mt-2">
  <strong>Total confirmado: ${itemsGuardados.reduce((acc, p) => acc + (p.price || 0) * p.cantidad, 0)}</strong>
</div>

</div>

        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
        <Button variant="success" onClick={confirmarPedido}>Confirmar pedido</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AgregarPedidoModal;
